import React from "react";
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    makeStyles
} from "@material-ui/core";
import { Scrollbars } from "react-custom-scrollbars";
import LinhaTabelaLaboratorio from "./LinhaTabelaLaboratorio";
import { TEXT_SECONDARY_COLOR } from "../../../theme";

export const TabelaListaLaboratorio = ({
    laboratorios,
    handleClickLinha,
    codigoSelecionado
}) => {
    const classes = useStyles();

    return (
        <>
            <Table style={{ display: "table", width: "100%" }} className={classes.table}>
                <TableHead size="small" className={classes.headerFixed} style={{ display: "table", width: "100%" }}>
                    <TableRow className={classes.linhaTabela}>
                        <TableCell className={classes.celulaTabela} style={{ minWidth: '90px', maxWidth: '90px'}}>
                            <Typography className={classes.larguraTexto}>
                                Código
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.celulaTabela} style={{ minWidth: '150px', maxWidth: '150px'}}>
                            <Typography className={classes.larguraTexto}>
                                Nome Laboratório
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.celulaTabela} style={{ minWidth: '110px', maxWidth: '110px'}}>
                            <Typography className={classes.larguraTexto}>
                                Cidade
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.celulaTabela} style={{ minWidth: '80px', maxWidth: '80px'}}>
                            <Typography className={classes.larguraTexto}>
                                Situação
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.celulaTabela} style={{ minWidth: '150px', maxWidth: '150px'}}>
                            <Typography className={classes.larguraTexto}>
                                Responsável
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.celulaTabela} style={{ minWidth: '130px', maxWidth: '130px'}}>
                            <Typography className={classes.larguraTexto}>
                                CNPJ
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
            </Table>
            <Scrollbars style={{ maxHeight: 'calc(100vh - 450px)', width: '100%' }}>
                <Table stickyHeader size="small">
                    <TableBody style={{ width: '100%', display: 'table' }}>
                        {laboratorios
                            ?.map((row) => (
                                <LinhaTabelaLaboratorio
                                    key={row.id}
                                    laboratorio={row}
                                    handleClickLinha={handleClickLinha}
                                    codigoSelecionado={codigoSelecionado}
                                />
                            ))}
                    </TableBody>
                </Table>
            </Scrollbars>
        </>
    );
};

const useStyles = makeStyles(() => ({
    table: {
        "& .MuiTableCell-head":{
            backgroundColor: '#F2F2F8 !important',
        }
    },
    headerFixed: {
        position: "sticky",
        backgroundColor: '#F2F2F8 !important',
        borderBottom: '1px solid #F3F3F3',
    },
    linhaTabela: {
        padding: "8px",
        height: "31px",
    },
    celulaTabela: {
        border: 0,
        padding: "4px 8px 4px 16px",
        color: TEXT_SECONDARY_COLOR,
    },
    larguraTexto: {
        fontSize: '12px',
      }
}));

export default TabelaListaLaboratorio;
